// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { connect } from 'react-redux';
import SiteMaintenanceBannerView from '../views/SiteMaintenanceBanner.view';
import {
  getSiteMaintainanceBannerData,
  getSiteMaintainancePopupEnabled,
} from '../../../../../reduxStore/selectors/session.selectors';
import { getSiteMaintenanceBannerState } from '../../../../../reduxStore/selectors/global.selectors';
import { toggleSiteMaintenanceBanner } from '../../../../../reduxStore/actions';

class SiteMaintenanceBannerContainer extends React.Component {
  componentDidMount() {}

  render() {
    const {
      siteMaintenanceBannerData,
      siteMaintenanceBannerState,
      toggleSiteMaintenanceBannerAction,
      siteMaintenacePopupEnabled,
    } = this.props;
    return (
      <SiteMaintenanceBannerView
        siteMaintenanceBannerData={siteMaintenanceBannerData}
        siteMaintenanceBannerState={siteMaintenanceBannerState}
        closeSiteMaintenanceBannerState={toggleSiteMaintenanceBannerAction}
        siteMaintenacePopupEnabled={siteMaintenacePopupEnabled}
        globalError
      />
    );
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    toggleSiteMaintenanceBannerAction: (payload) => dispatch(toggleSiteMaintenanceBanner(payload)),
  };
};

export const mapStateToProps = (state) => {
  return {
    siteMaintenanceBannerData: getSiteMaintainanceBannerData(state),
    siteMaintenanceBannerState: getSiteMaintenanceBannerState(state),
    siteMaintenacePopupEnabled: getSiteMaintainancePopupEnabled(state),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteMaintenanceBannerContainer);
export { SiteMaintenanceBannerContainer as SiteMaintenanceBannerContainerVanilla };
